import React from "react";
import Checkbox from "Components/common/Checkbox/Checkbox";

class FieldSetAsTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            searchIsLoading: false
        }

        _.map(["onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onChange() {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "isTemplate", value: this.props.checked ? false : true }});
        }
    }

    render() {
        return (
            <label class="custom-checkbox">
                <Checkbox checked={ this.props.checked } onChange={ this.onChange } />
                Set as Workstream Template
            </label>
        );
    }
}

export default FieldSetAsTemplate;
